import "./App.css";
import { Routes, Route } from "react-router-dom";

import Header from "./components/header/header";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Homepage from "./homepage/Homepage";
import Login from "./login/Login";
import Resgiter from "./Register/Register";
import Profile from "./profile/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import VerifyEmail from "./VerifyEmail/VerifyEmail";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ResetPassword from "./ResetPassword/ResetPassword";
import About from "./pages/About/About";
import Services from "./pages/Services/Services";
import HowWeWork from "./pages/HowWeWork/HowWeWork";
import Testimonials from "./pages/Testimonials/Testimonials";
import Resources from "./pages/Resources/Resources";
import Contact from "./pages/Contact/Contact";
import Admin from "./pages/Admin/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse/TermsOfUse";
import ComplaintsProcess from "./pages/ComplaintsProcess/ComplaintsProcess";


function App() {
  return (
    <>
      <ScrollToTop />
      <Header />   {/* ✅ inside Router now */}

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/how-we-work" element={<HowWeWork />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/complaints" element={<ComplaintsProcess />} />
        <Route path="/complaints-process" element={<ComplaintsProcess />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Resgiter />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route 
          path="/my-profile" 
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          } 
        />
      </Routes>

      <Footer />   {/* ✅ inside Router now */}
    </>
  );
}

export default App;
